import { connect } from "react-redux";
import { NotebookExpDesignTab as Component } from "./NotebookExpDesignTab";
import { setChapter } from "@learningblocks/exp-redux";
import {
  getTitle,
  getMenuList,
  getCurrentMenu,
  getDescription,
  getNextMenuValue,
  getCurrentChapterComponents,
} from "./NotebookExpDesignTab.selector";

function mapStateToProps(state) {
  return {
    components: getCurrentChapterComponents(state),
    menuList: getMenuList(state),
    currentMenu: getCurrentMenu(state),
    nextMenuValue: getNextMenuValue(state),
    title: getTitle(state),
    description: getDescription(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSetChapter: (params) => {
      dispatch(setChapter(params));
    },
  };
}

export const NotebookExpDesignTab = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
